document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-td-chips]').forEach(function (chipRow) {
    const section = chipRow.closest('.td-section');
    const grid = section?.querySelector('[data-td-grid]');
    if (!grid) return;
    const count = section.querySelector('[data-td-count]');
    const chips = chipRow.querySelectorAll('.chip');
    const cards = grid.querySelectorAll('.td-card');

    // One delegated listener instead of one per chip.
    chipRow.addEventListener('click', function (event) {
      const chip = event.target.closest('.chip');
      if (!chip) return;
      chips.forEach(function (c) {
        const isActive = c === chip;
        c.classList.toggle('active', isActive);
        c.setAttribute('aria-pressed', String(isActive));
      });
      const brand = chip.getAttribute('data-brand-filter');
      let shown = 0;
      cards.forEach(function (card) {
        const matches = brand === 'all' || card.getAttribute('data-brand') === brand;
        card.hidden = !matches;
        if (matches) shown += 1;
      });
      if (count) count.textContent = shown;
    });
  });
});
